import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/AuthContext";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { TaskFilter } from "../../types";

export async function fetchFilters(): Promise<TaskFilter[]> {
  const { data, error } = await supabase
    .from("task_filters")
    .select("*")
    .order("order_position", { ascending: true });
  if (error) throw error;
  return (data ?? []) as TaskFilter[];
}

export function useFilters() {
  const { user } = useAuth();
  return useQuery({
    queryKey: queryKeys.filters,
    queryFn: fetchFilters,
    enabled: !!user,
  });
}
